module.exports = __webpack_public_path__ + "img/26a-produtividade-geral-show.1ea4e936.png";